define('modules/lp_integration/collections/variant_collection',['require','exports','module','modules/page_generator/collections/variant_collection'],function(require, exports, module){
  "use strict";
  var PageGeneratorVariantCollection = require("modules/page_generator/collections/variant_collection");
  module.exports = PageGeneratorVariantCollection;
});
